import {ChartType, ReportChartType} from '../../constants'
import VerticalBarsChartStrategy from './doStrategy/VerticalBarsChartStrategy'
import HorBarsChartStrategy from './doStrategy/HorBarsChartStrategy'
import PieChartStrategy from './doStrategy/PieChartStrategy'
import {filterArrayByArrayOfIds} from '../../../atUtils'
import ATReportParamsStringBuilder from '../../reportParamsStringBuilder/ATReportParamsStringBuilder'
import ChartPDFOvertimeParametersFormattingStrategy from './formatters/ChartPDFOvertimeParametersFormattingStrategy'
import {DateFormat} from '../../../date_format'
import ChartPDFLeaveParametersFormattingStrategy from './formatters/ChartPDFLeaveParametersFormattingStrategy'
import ChartPDFWorkingHoursCostBillingParametersFormattingStrategy from './formatters/ChartPDFWorkingHoursCostBillingParametersFormattingStrategy'
import ChartPDFBalanceParametersFormattingStrategy from './formatters/ChartPDFBalanceParametersFormattingStrategy'
import ChartPDFParametersFormattingStrategy from './formatters/ChartPDFParametersFormattingStrategy'

/**
 *
 * @param chartType
 * @returns {BaseCreateDefinitionObjectStrategy}
 */
export const getCreateDefinitionObjectStrategy = function(chartType) {
    switch (chartType) {
        case ChartType.VERTICAL_BAR:
            return new VerticalBarsChartStrategy()
        case ChartType.HORIZONTAL_BAR:
            return new HorBarsChartStrategy()
        case ChartType.PIE_CHART:
            return new PieChartStrategy()
    }
}

/**
 * Get calculator of total pages.
 * In feature it may be separate class
 * @param chartType type of target chart
 * @returns {*} - calculator
 */
export const getTotalPagesCalculator = function(chartType) {
    return getCreateDefinitionObjectStrategy(chartType)
}

/**
 * Get calculator of max values on page
 * In feature it may be separate class
 * @param chartType type of target chart
 * @returns {*}
 */
export const getMaxValuesCalculator = function(chartType) {
    return getCreateDefinitionObjectStrategy(chartType)
}

/**
 * Get chart image sizes in pixels
 * @param chartType
 * @param lengthOfDataList length of all data in pdf
 * @param pdfPrintParameters
 * @returns {{width: number, height: number}}
 */
export const getChartImageDimensionsInPixels = function(chartType, lengthOfDataList, pdfPrintParameters) {
    const pdfImageSizes = getCreateDefinitionObjectStrategy(chartType).getChartImageDimensions(lengthOfDataList, pdfPrintParameters)
    const chartSizesMultiplyCoeff = 2
    return {
        width: pdfImageSizes.w * chartSizesMultiplyCoeff,
        height: pdfImageSizes.h * chartSizesMultiplyCoeff
    }
}

/**
 * Get users array filtered by authorizationInfo
 */
export const getUsersFilteredByAuthorizer = function(users, authorizationInfo) {
    return filterArrayByArrayOfIds(users, authorizationInfo.availableUserIds)
}

/**
 * Get chart PDF parameters formatting strategy by chart type
 * @returns {ChartPDFParametersFormattingStrategy}
 */
export const getParametersFormattingStrategy = function({chartTypeValue, selectorsData, dateFormat, reportAuthorizationInfo}) {
    const dateFormatForFileName = new DateFormat('yyyy-MM-dd')
    switch (chartTypeValue) {
        case ReportChartType.TOTAL_WORKING_HOURS:
        case ReportChartType.APPROVED_WORKING_HOURS:
            return (new ChartPDFWorkingHoursCostBillingParametersFormattingStrategy())
                .init(
                    {...selectorsData, users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.taskChartsAuthorizationInfo)},
                    dateFormat,
                    dateFormatForFileName,
                    reportAuthorizationInfo.taskChartsAuthorizationInfo,
                    ATReportParamsStringBuilder,
                )
        case ReportChartType.COST_OF_WORK:
        case ReportChartType.BILLABLE_AMOUNTS:
            return (new ChartPDFWorkingHoursCostBillingParametersFormattingStrategy())
                .init(
                    {...selectorsData, users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.billingChartsAuthorizationInfo)},
                    dateFormat,
                    dateFormatForFileName,
                    reportAuthorizationInfo.billingChartsAuthorizationInfo,
                    ATReportParamsStringBuilder,
                )
        case ReportChartType.LEAVE_HOURS:
            return (new ChartPDFLeaveParametersFormattingStrategy())
                .init(
                    {...selectorsData, users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.taskChartsAuthorizationInfo)},
                    dateFormat,
                    dateFormatForFileName,
                    reportAuthorizationInfo.balanceChartsAuthorizationInfo,
                    ATReportParamsStringBuilder,
                )
        case ReportChartType.PTO_BALANCE:
        case ReportChartType.SICK_DAYS_BALANCE:
            return (new ChartPDFBalanceParametersFormattingStrategy())
                .init(
                    {...selectorsData, users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.balanceChartsAuthorizationInfo)},
                    dateFormat,
                    dateFormatForFileName,
                    reportAuthorizationInfo.balanceChartsAuthorizationInfo,
                    ATReportParamsStringBuilder,
                )
        case ReportChartType.OVERTIME_HOURS:
            return (new ChartPDFOvertimeParametersFormattingStrategy())
                .init(
                    {...selectorsData, users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.balanceChartsAuthorizationInfo)},
                    dateFormat,
                    dateFormatForFileName,
                    reportAuthorizationInfo.balanceChartsAuthorizationInfo,
                    ATReportParamsStringBuilder,
                )
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/utils.js